import React from 'react';
import SingleProjectUI from '../core-ui/single-project/single-project-ui';

const SingleProject = (props) => <SingleProjectUI {...props} />;

export default SingleProject;
